import BehaviorFormElements from '../../constants/behavior_form_elements';

import FormEvents from 'form/events/form_events';
import EnumValidator from 'validator/enum_validator';

export default class BehaviorEvent {
	_element;
	_event;
	_fieldId;
	_gridId;
	_actionId;

	constructor(props = {}) {
		Object.keys(props)
		.forEach((propName) => this[propName] = props[propName]);
	}

	get element() {
		return this._element;
	}

	set element(value) {
		EnumValidator.validate(value, BehaviorFormElements);
		this._element = BehaviorFormElements[value];
	}

	get event() {
		return this._event;
	}

	set event(value) {
		EnumValidator.validate(value, FormEvents);
		this._event = FormEvents[value];
	}

	get fieldId() {
		return this._fieldId;
	}

	set fieldId(value) {
		this._fieldId = value;
	}

	get gridId() {
		return this._gridId;
	}

	set gridId(value) {
		this._gridId = value;
	}

	get actionId() {
		return this._actionId;
	}

	set actionId(value) {
		this._actionId = value;
	}
}
